import { Gender } from '@shared/enums';
import { DropdownOption } from '@shared/interfaces/dev';

export const GENDERS: DropdownOption<Gender>[] = [
  {
    label: 'Homme',
    value: Gender.MALE,
  },
  {
    label: 'Femme',
    value: Gender.FEMALE,
  },
  {
    label: 'Autre',
    value: Gender.OTHER,
  },
  {
    label: 'Non spécifié',
    value: Gender.NOT_SPECIFIED,
  },
] as const;
